import { qsa } from "@fluorescent/dom";
import { section } from "@/neon";

import { backgroundVideoHandler } from "@/lib/a11y";
import { animateMosaicGrid } from "@/lib/animation";

const selectors = {
  video: ".mosaic-grid__item-video",
};

section("mosaic-grid", {
  onLoad() {
    this.animateMosaicGrid = animateMosaicGrid(this.container);
    const videos = qsa(selectors.video, this.container);
    this.videoHandlers = [];

    if (videos.length) {
      videos.forEach(video => {
        this.videoHandlers.push(backgroundVideoHandler(video.parentNode));
      });
    }
  },

  onUnload() {
    this.animateMosaicGrid?.destroy();
    this.videoHandlers.forEach(handler => handler());
  },
});
